import { useEffect, useRef, useState } from 'react';
import { wsClient } from '../api/realWebSocket';
import { api } from '../api/client';
import { useAppStore } from '@/store/appStore';

export function useTelemetry(deviceId: string) {
  const [telemetry, setTelemetry] = useState<any>(null);
  useEffect(() => {
    const unsub = wsClient.on('telemetry_update', (data) => {
      if (data.deviceId === deviceId) setTelemetry(data);
    });
    return () => unsub();
  }, [deviceId]);
  return telemetry;
}

export function useAlerts() {
  const [newAlerts, setNewAlerts] = useState<any[]>([]);
  useEffect(() => {
    const unsub = wsClient.on('alert_created', (data) => {
      setNewAlerts((prev) => [data, ...prev].slice(0, 50));
    });
    return () => unsub();
  }, []);
  return newAlerts;
}

export function useJobProgress(jobId: string) {
  const [progress, setProgress] = useState<any>(null);
  useEffect(() => {
    const unsub = wsClient.on('job_progress', (data) => {
      if (data.jobId === jobId) setProgress(data);
    });
    return () => unsub();
  }, [jobId]);
  return progress;
}

export function useDevicePresence() {
  const [presence, setPresence] = useState<Record<string, string>>({});
  useEffect(() => {
    const unsub = wsClient.on('presence_update', (data) => {
      setPresence((prev) => ({ ...prev, [data.deviceId]: data.status }));
    });
    return () => unsub();
  }, []);
  return presence;
}

export function useWsConnection() {
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(false);
  const setWsConnected = useAppStore((s) => s.setWsConnected);

  useEffect(() => {
    if (wsRef.current) return;
    wsRef.current = true;

    async function connect() {
      try {
        const res: any = await api.post('/ws/token', { purpose: 'dashboard' });
        const payload = res?.token ? res : (res?.data ?? res);
        const token = payload?.token;
        const wsUrl = payload?.wsUrl;
        if (token) {
          await wsClient.connect(token, wsUrl);
          setConnected(true);
          setWsConnected(true);
        }
      } catch {
        setConnected(false);
        setWsConnected(false);
      }
    }

    connect();
    return () => {
      wsClient.disconnect();
      setWsConnected(false);
    };
  }, [setWsConnected]);

  return connected;
}
